import mixpanel from 'mixpanel-browser';

/**
 * Gets the query parameter for the passed param from the URL
 * (Mixpanel example code from their site)
 * @param {String} url - The URL to search
 * @param {String} param - The parameter to search for
 * @returns {String} - The value of the parameter
 */
const getQueryParam = (url, param) => {
  // Expects a raw URL
  param = param.replace(/[[]/, '[').replace(/[]]/, ']');
  var regexS = '[?&]' + param + '=([^&#]*)',
    regex = new RegExp(regexS),
    results = regex.exec(url);
  if (results === null || (results && typeof results[1] !== 'string' && results[1].length)) {
    return '';
  } else {
    return decodeURIComponent(results[1]).replace(/\W/gi, ' ');
  }
};

/**
 * Sets utm campaign parameters for mixpanel based on the URL
 * (Mixpanel example code from their site)
 */
const campaignParams = () => {
  var campaign_keywords = 'utm_source utm_medium utm_campaign utm_content utm_term'.split(' '),
    kw = '',
    params = {},
    first_params = {};
  var index;
  for (index = 0; index < campaign_keywords.length; ++index) {
    kw = getQueryParam(document.URL, campaign_keywords[index]);
    if (kw.length) {
      params[campaign_keywords[index] + ' [last touch]'] = kw;
    }
  }
  for (index = 0; index < campaign_keywords.length; ++index) {
    kw = getQueryParam(document.URL, campaign_keywords[index]);
    if (kw.length) {
      first_params[campaign_keywords[index] + ' [first touch]'] = kw;
    }
  }

  // Update their user profile with the campaign params
  // (if they are not identified yet, this will instead be queued)
  mixpanel.disguise.people.set(params);
  mixpanel.disguise.people.set_once(first_params);

  mixpanel.disguise.register(params);

  mixpanel.disguise.hasAliasBeenCalled = false;
};

const mixpanelInit = () => {
  mixpanel.init(
    import.meta.env.VITE_MIXPANEL_TOKEN,
    {
      debug: import.meta.env.VITE_MIXPANEL_ENV === 'local',
      api_host: import.meta.env.VITE_MIXPANEL_HOST,
      batch_flush_interval_ms: 1000,
    },
    'disguise'
  );

  campaignParams();
};

export default mixpanelInit;
